import React from 'react';

export function useMergeRefs<Instance>(
    refs: Array<React.Ref<Instance> | undefined>
): React.RefCallback<Instance> | null | React.RefObject<Instance> {
    return React.useMemo(() => {
        const validRefs = refs.filter((ref) => ref) as React.Ref<Instance>[];
        if (validRefs.length <= 1) {
            return validRefs[0] ?? null;
        }
        return (value) => {
            validRefs.forEach((ref) => {
                if (typeof ref === 'function') {
                    ref(value);
                } else if (typeof ref === 'object' && ref && 'current' in ref) {
                    (ref as React.MutableRefObject<Instance | null>).current = value;
                }
            });
        };
    }, refs);
}
